// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"742a46e2","789":"648a8c46","844":"9b504fa9"}[chunkId] + ".chunk.css";
};